@if (!isStepPrerequisiteCompleted()) {
  <app-previous-step-incomplete-notice />
} @else {
  <app-invitation-table [phaseConfig]="rfiPhaseConfig()" [projectId]="projectId" />
  <app-rfi-coverage-analysis-dialog
    [(visible)]="analysisVisible"
    [(activeTab)]="analysisTab"
    [tool]="analysisTool()"
    [requirements]="coverageRequirements()"
    [countryEmployees]="countryEmployees()"
    [moduleFunctions]="moduleFunctions()"
  />
}

<ng-template #coverageCell let-item>
  <app-rfi-coverage-cell [coverage]="item.coverage" (analysisRequested)="openAnalysis(item)" />
</ng-template>

<ng-template #analysisCountCell let-item let-column="column">
  <span class="inline-flex items-center gap-1 whitespace-nowrap">
    {{ column.valueExtractor(item) }}
    <app-rfi-analysis-info-button
      [testId]="'open-coverage-analysis-' + analysisTabFor(column)"
      (clicked)="openAnalysis(item, analysisTabFor(column))"
    />
  </span>
</ng-template>
